import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";

//componentes
import "./asociarDonante.css";
import Alert from "../../modal/alert";

class AsociarDonantesAction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idmateria: "",
      idcurso: "",
      descripcion: "",
      trimestre: "",
      trimestre2: "",
      cantidadE: "",
      iddonante: "",
      anoEscolar: "",
      anoEscolarN: moment().format("YYYY"),
      imaterias: [],
      icursos: [],
      idonantes: [],
      ianoEscolar: [],
      idescripcionE: [],
      listaOn: false,
      modificarOn: false,
      verplanillaOn: false,
      asientoOn: false,
      planAnualOn: false,
      donante: "",
      ruc: "",
      cedulaPaciente:'',
      ipaciente:[],
      iasociarD:[],
    };
  }

  limpiar = () => {
    this.setState({
      idmateria: "",
      //anoEscolar: "",
      //idcurso: "",
      descripcion: "",
      trimestre: "",
      trimestre2: "",
      cantidadE: "",
      iddonante: "",
      idonantes: [],
      listaOn: false,
      modificarOn: false,
      asientoOn: false,
      planAnualOn: false,
      donante: "",
      ruc: "",
      cedulaPaciente:'',
      ipaciente:[],
      iasociarD:[],
    });
  };

  limpiar2(e) {
    this.setState({ idcurso: "" });
    this.limpiar();
    this.buscarPlanE();
  }

  onChange(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  onChange2(e) {
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
      iasociarD:[],
    });
    this.buscarAsociar(e.target.value);
  }

  buscarAsociar(e) {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("iddonante", e);
      data.append("boton", "buscarAsociarDonantes");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/planEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              iasociarD: res.data.variable2,
            });
          } else {
          }
        });
    }
  }

  cerrarLista = () => {
    //console.log(this.state.listaOn)
    if (this.state.asientoOn) {
      this.setState({
        asientoOn: false,
        anoEscolar: "",
        trimestre: "",
        trimestre2: "",
      });
    }
    if (!this.state.asientoOn) {
      this.setState({
        asientoOn: true,
      });
    }
  };

  cerrarListaAnual = () => {
    //console.log(this.state.listaOn)
    if (this.state.planAnualOn) {
      this.setState({
        planAnualOn: false,
        anoEscolar: "",
        trimestre: "",
      });
    }
    if (!this.state.planAnualOn) {
      this.setState({
        planAnualOn: true,
      });
    }
  };

  consultar(e) {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("idmaestroE", e);
      data.append("boton", "buscarDonantesI");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/planEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.setState({
              iddonante: res.data.variable2,
              donante: res.data.variable3,
              ruc: res.data.variable4,
              modificarOn: true,
            });
          } else {
          }
        });
    }
  }

  modificar = () => {
    if (this.state.iddonante.length > 0) {
      let data = new FormData();
      data.append("idmaestroE", this.state.iddonante);
      data.append("donante", this.state.donante);
      data.append("ruc", this.state.ruc);
      data.append("boton", "modificarDonante");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/planEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.limpiar();
            this.buscarPlanE();
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Maestro de Donantes.",
              cuerpoM: res.data.variable2,
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Maestro de Donantes.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Maestro de Donantes.",
        cuerpoM: "Ocurrio un Error, verifique por Favor.",
      });
    }
  };

  guardar = () => {
    if (
      this.state.donante.length > 0 &&
      this.state.cedulaPaciente.length > 0
    ) {
      let data = new FormData();
      data.append("iddonante", this.state.donante);
      data.append("cedulaPaciente", this.state.cedulaPaciente);
      data.append("boton", "asociarDonante");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/planEvaluacion.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            //this.limpiar();
            this.buscarAsociar(this.state.donante);
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Asignar Materias.",
              cuerpoM: res.data.variable2,
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Asignar Materias.",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Materias.",
        cuerpoM: "Debe Ingresar un Donante y un Ruc o Cédula.",
      });
    }
  };

  eliminar = (e) => {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("idasociarD", e);
      data.append("boton", "eliminarAsociarDonantes");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/planEvaluacion.php";
      axios.post(xurl, data, config).then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Asignar Materias.",
            cuerpoM: res.data.variable2,
            iasociarD:[],
          });
          //this.limpiar();
          this.buscarAsociar(this.state.donante);
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Asignar Materias.",
            cuerpoM: res.data.variable2,
          });
        }
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Asignar Materias.",
        cuerpoM:
          "Debe existir un registro para poder eliminar la MAteria Asignada.",
      });
    }
  };

  buscarPlanE = (e) => {
    let data = new FormData();
    data.append("boton", "buscarDonantes");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/planEvaluacion.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xidonantes = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            idonantes: xidonantes,
          });
        } else {
          this.setState({
            idonantes: [],
          });
        }
      });
  };

  
  
  buscarAnioEscolar = () => {
    let data = new FormData();
    data.append("boton", "buscarAnioEscolar");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/maternal.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          //anoEscolar: res.data.variable2,
          ianoEscolar: res.data.variable3,
        });
      }
    });
  };

  buscarDE = () => {
    let data = new FormData();
    data.append("boton", "buscarDE");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/descripcionEva.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let xidescripcionE = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            idescripcionE: xidescripcionE,
          });
        } else {
          this.setState({
            idescripcionE: [],
          });
        }
      });
  };

  buscarPacientes = () => {
    let data = new FormData();
    data.append("boton", "buscarPacientes");
    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/terapias/backend/maternal.php";
    axios.post(xurl, data, config).then((res) => {
      if (res.data.variable1) {
        this.setState({
          //anoEscolar: res.data.variable2,
          ipaciente: res.data.variable2,
        });
      }
    });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  componentDidMount() {
    this.buscarPlanE();
    this.buscarPacientes();
    // this.buscarSalones();
    // this.buscarAnioEscolar();
    // this.buscarDE();
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>ASOCIAR DONANTES. </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}

          <div className="cont-listmedi row">
            <div className="cont-personal col-12">
            <div className="contenedorcedula1f col-4">
                <select
                  id="donante"
                  name="donante"
                  value={this.state.donante}
                  onChange={this.onChange2.bind(this)}
                >
                  <option>-- Seleccione Donante --</option>
                  {this.state.idonantes.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable2}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="contenedorcedula1f col-4">
                <select
                  id="cedulaPaciente"
                  name="cedulaPaciente"
                  value={this.state.cedulaPaciente}
                  onChange={this.onChange.bind(this)}
                >
                  <option>-- Seleccionar Paciente --</option>
                  {this.state.ipaciente.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable2}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="xcontenedorcedula1x col-12">
              <button
                className={this.state.modificarOn ? "botonOf" : "boton"}
                onClick={this.state.modificarOn ? "" : this.guardar.bind(this)}
              >
                Guardar
              </button>
              <button className="boton" onClick={this.limpiar2.bind(this)}>
                Limpiar
              </button>
              <Link to="/">
                <button className="boton">Salir</button>
              </Link>
            </div>
          </div>

          <div className="cont-listmedix row">
            <div className="listcxcx col-12">
              <table className="tablacxcx" border="1">
                <thead>
                  <tr>
                    <th className="titucxc1">NOMBRE PACIENTE.</th>
                    <th className="titucxc3xpe">
                      <span className="titulo-eliminar">
                        <span className="cerrarme3"></span>
                      </span>
                    </th>
                  </tr>
                </thead>

                {this.state.iasociarD.map((item, i) => {
                  return (
                    <tr
                      className={i % 2 === 0 ? "odd" : "odd"}
                      key={item.variable1}
                      id="tabla"
                    >
                      <td className="totalescxcx">{item.variable2}</td>
                      
                      <td className="xcerr">
                        <span
                          className="cerrarme1"
                          onClick={this.eliminar.bind(this, item.variable1)}
                        ></span>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AsociarDonantesAction;
